<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
    components: {

    },
    methods: {
    },
    mounted () {
    }
  }
</script>

<style>
  body {
    margin: 0;
  }
  /* .container {
    background: #fff;
    padding: 20px;
    border-radius: 10px;
  } */
  .container {
    background: #fff;
    padding: 15px;
    border: 1px solid #ededed;
    /* border-radius: 3px; */
    /* box-shadow: 0 1px 2px rgba(0,0,0,0.07) */
  }
  .h3 {
    font-size: 16px;
    font-weight: bold;
  }
  /* .container {
    background: #fff;
    padding: 15px;
    box-shadow: 1px 1px 2px 1px #ccc;
  } */
  .form-container {
    max-width: 650px;
  }
  a:active {
    text-decoration: none;
  }
  #app {
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
  h5 {
    margin-top: 0;
    padding-left: 8px;
    border-left: 2px solid #409EFF;
  }
  .el-upload-list__item {
    transition: none !important;
  }
</style>
